interface ILoyaltyHelpTermsData {
  title: string;
  content: string[];
  classname?: string;
}

export const loyaltyHelpTermsData: ILoyaltyHelpTermsData[] = [
  {
    title: "loyalty.terms1.title",
    content: ["loyalty.terms1.text"],
    classname: "single",
  },
  {
    title: "loyalty.terms2.title",
    content: [
      "loyalty.terms2.text1",
      "loyalty.terms2.text2",
      "loyalty.terms2.text3",
      "loyalty.terms2.text4",
      "loyalty.terms2.text5",
      "loyalty.terms2.text6",
      "loyalty.terms2.text7",
    ],
    classname: "",
  },
  {
    title: "loyalty.terms3.title",
    content: [
      "loyalty.terms3.text1",
      "loyalty.terms3.text2",
      "loyalty.terms3.text3",
      "loyalty.terms3.text4",
      "loyalty.terms3.text5",
      "loyalty.terms3.text6",
      "loyalty.terms3.text7",
      "loyalty.terms3.text8",
      "loyalty.terms3.text9",
      "loyalty.terms3.text10",
      "loyalty.terms3.text11",
      "loyalty.terms3.text12",
      "loyalty.terms3.text13",
      "loyalty.terms3.text14",
      "loyalty.terms3.text15",
      "loyalty.terms3.text16",
      "loyalty.terms3.text17",
      "loyalty.terms3.text18",
      "loyalty.terms3.text19",
      "loyalty.terms3.text20",
      "loyalty.terms3.text21",
      "loyalty.terms3.text22",
      "loyalty.terms3.text23",
      "loyalty.terms3.text24",
      "loyalty.terms3.text25",
      "loyalty.terms3.text26",
      "loyalty.terms3.text27",
      "loyalty.terms3.text28",
      "loyalty.terms3.text29",
      "loyalty.terms3.text30",
      "loyalty.terms3.text31",
      "loyalty.terms3.text32",
      "loyalty.terms3.text33",
      "loyalty.terms3.text34",
      "loyalty.terms3.text35",
      "loyalty.terms3.text36",
      "loyalty.terms3.text37",
      "loyalty.terms3.text38",
      "loyalty.terms3.text39",
      "loyalty.terms3.text40",
      "loyalty.terms3.text41",
    ],
    classname: "",
  },
  {
    title: "loyalty.terms4.title",
    content: [
      "loyalty.terms4.text1",
      "loyalty.terms4.text2",
      "loyalty.terms4.text3",
      "loyalty.terms4.text4",
      "loyalty.terms4.text5",
      "loyalty.terms4.text6",
      "loyalty.terms4.text7",
      "loyalty.terms4.text8",
      "loyalty.terms4.text9",
      "loyalty.terms4.text10",
      "loyalty.terms4.text11",
      "loyalty.terms4.text12",
    ],
    classname: "lastitem",
  },
];
